(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["monday-style"] = factory(require("react"));
	else
		root["monday-style"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__8156__) => {
return 